import { Column, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const CandidateResumeRecoveryDialog = ({
  canRetry,
  isLoading,
  onClose,
  onRetry,
  open,
}: {
  canRetry: boolean;
  isLoading: boolean;
  onClose: () => void;
  onRetry: () => void;
  open: boolean;
}) => {
  /* Render */
  const renderMessage = () => {
    if (canRetry) {
      return "The candidate and resume are saved, but resume processing failed. Retry this step to finish adding the candidate to the pipeline.";
    }
    return "The candidate is saved, but the resume upload could not be confirmed. Check their documents before uploading again. The candidate has not been added to the pipeline.";
  };

  const render = () => {
    return (
      <Dialog
        onOpenChange={(next) => {
          if (!next && !isLoading) onClose();
        }}
        open={open}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Resume needs attention</DialogTitle>
          </DialogHeader>
          <Column className="gap-4">
            <Text>{renderMessage()}</Text>
            <Row className="justify-end gap-2">
              <Button
                disabled={isLoading}
                onClick={onClose}
                variant="secondary"
              >
                Close
              </Button>
              {canRetry ? (
                <Button disabled={isLoading} onClick={onRetry}>
                  {isLoading ? "Processing resume…" : "Retry resume"}
                </Button>
              ) : null}
            </Row>
          </Column>
        </DialogContent>
      </Dialog>
    );
  };
  return render();
};
